var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"w-100"},[(_vm.loading)?_c('LoadingSpinner'):_c('div',[(_vm.workspace_domain.length > 0)?[_c('DeleteDomains',{key:_vm.keydomains,attrs:{"workspace_domain":_vm.workspace_domain,"complete":true},on:{"refresh":function($event){return _vm.getDomainFree()}}})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }